<template>
  <div class="commlist">
    <van-pull-refresh v-model="state.refreshing" @refresh="onRefresh">
      <van-list
        :immediate-check="false"
        v-model:loading="state.loading"
        :finished="state.finished"
        finished-text="没有更多了"
        @load="onLoad"
      >
        <div class="header_img" v-if="header_ad.ad_src">
          <template v-if="header_ad.ad_link">
            <a :href="header_ad.ad_link" target="_blank" rel="noopener noreferrer">
              <van-image width="100%" :src="header_ad.ad_src" />
            </a>
          </template>
          <template v-else>
            <van-image width="100%" :src="header_ad.ad_src" />
          </template>
        </div>
        <transition-group name="van2-slide-right">
          <div style="padding-top:10px; padding-bottom:2px;border-bottom: 1px solid #f2f2f2; width:95%; margin:0px auto;">
            <CommonItem
            v-for="item in TopListInfo.list"
            :key="item.id"
            :article_info="item"
            :important="true"
          ></CommonItem>
          </div>
          
        </transition-group>
        <FirstSwiper></FirstSwiper>
        <div class="header_24" ref="Hour24">
          <van-image
            width="75%"
            src="https://vmsres.dianzhenkeji.com/0/hnr/2021/4/28/1387336258732318720.jpg"
          />
        </div>
        <transition-group name="van2-slide-right">
          <CommonItem v-for="item in RecommendListInfo.list" :key="item.id" :article_info="item"></CommonItem>
        </transition-group>
      </van-list>
    </van-pull-refresh>
  </div>
</template>

<script>
import { reactive, computed, inject, toRefs, ref, watch, onMounted } from "vue";
import { useStore } from "vuex";
import CommonItem from "./CommonItem";
import FirstSwiper from "./FirstSwiper";

export default {
  props: {
    tagsInfo: Object,
    index: Number,
  },
  components: {
    CommonItem,
    FirstSwiper,
  },
  setup(props) {
    // vuex
    const store = useStore();

    const { index } = toRefs(props);

    const active = inject("active", 0);

    const scrollTop = inject("scrollTop", 0);

    // 获取是否有广告条
    const ad_src = document.querySelector("#meta_data #ad").getAttribute("data-src");
    const ad_link = document.querySelector("#meta_data #ad").getAttribute("data-url");

    const header_ad = reactive({
      ad_src,
      ad_link,
    });



    // 获取列表
    // 使用computed包裹以后都需要使用.value来获取值
    // 包括对象本身
    const TopListInfo = computed(() => {
      return store.state.top_list_info;
    });

    const RecommendListInfo = computed(() => {
      return store.state.recommend_list_info;
    });

    const state = reactive({
      loading: false,
      finished: false,
      refreshing: false,
    });
    // 加载数据
    const onLoad = (fresh = false) => {
      console.log("触发底部加载f", state.loading);
      if (index.value == active.value) {
        if (fresh) {
          state.loading = true;
          state.refreshing = true;
          // 下拉刷新不需要缓存
          store.dispatch("getFirstPageInit", { cache: false }).then(() => {
            state.loading = false;
            state.refreshing = false;
          });

          return;
        }

        // 如果page等于totalpage的话说明已经加载结束了
        if (RecommendListInfo.value.page == RecommendListInfo.value.totalPage) {
          if (
            RecommendListInfo.value.page &&
            RecommendListInfo.value.totalPage
          ) {
            state.finished = true;
          }
        } else {
          state.loading = true;
          store
            .dispatch("getRecommendList", {
              page: RecommendListInfo.value.page + 1,
            })
            .then(() => {
              state.loading = false;
            })
            .catch(() => {
              state.loading = false;
            });
        }
      }
    };

    const onRefresh = () => {
      onLoad(true);
    };

    // 观测active的变动
    // 这个处理的是，防止被其他组件影响state的loading
    watch(active, () => {
      // 如果未完成
      if (!state.finished) {
        //检测是否再加载当中,避免边际影响
        if (state.loading) {
          state.loading = false;
        }
      }
    });

    // 处理hour24小时头
    const Hour24 = ref(null);
    // 注入修改专题的方法
    const updateFirstTitle = inject("updateFirstTitle");

    const onHourScroll = () => {
      // 如果活动是0的话才会改变，否则不会
      if (active.value == 0) {
        //获取页面卷去的高
        // document.documentElement.scrollTop
        if (scrollTop.value > Hour24.value.offsetTop) {
          updateFirstTitle("河南24小时");
        } else {
          updateFirstTitle("推荐");
        }
      }
    };
    // 监听window滚动
    onMounted(() => {
      window.addEventListener("scroll", onHourScroll, { passive: true }); //监听页面滚动
    });

    return {
      state,
      onLoad,
      onRefresh,
      TopListInfo,
      RecommendListInfo,
      onHourScroll,
      Hour24,
      header_ad
    };
  },
};
</script>


<style scoped>
.header_img {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #ffffff;
}
.header_24 {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #ffffff;
}
</style>
